import { render, staticRenderFns } from "./TenantList.vue?vue&type=template&id=32fcbe04&"
import script from "./TenantList.vue?vue&type=script&lang=js&"
export * from "./TenantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports